export default "__VITE_ASSET__CYhJJudu__"